import { FC } from 'react';
import { SpaceKind } from 'shared';

import { useScreenSize } from '../../../../hooks/index';
import { useDataRoomPresence } from '../../hooks/use-data-room-presence.hook';
import { SpaceSelection } from '../../types/data-room.types';
import { WorkspaceBrowserDesktop } from './workspace-browser-desktop';
import { WorkspaceBrowserMobile } from './workspace-browser-mobile';

export type WorkspaceBrowserPageProps = {
  isRecipientView?: boolean;
  selection: SpaceSelection;
};

export const WorkspaceBrowserPage: FC<WorkspaceBrowserPageProps> = ({
  isRecipientView = false,
  selection,
}) => {
  const { isMobile } = useScreenSize();
  const View = isMobile ? WorkspaceBrowserMobile : WorkspaceBrowserDesktop;
  const { space } = selection;
  useDataRoomPresence(isRecipientView && space.kind === SpaceKind.DATA_ROOM ? space.id : null);

  return <View isRecipientView={isRecipientView} selection={selection} />;
};
